var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"import-modal-welcome"},[_c('b-message',[_c('h1',[_vm._v(_vm._s(_vm.i18n.welcome))]),_vm._v(" "+_vm._s(_vm.i18n.descriptive_text)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }